import { cn } from '@realtyfeed/utils';
import type { ReactNode } from 'react';
import { FOCUS_RING } from '../focusRing';

/**
 * A row in the navbar's account menu — the `Profile` / `Log out` pair.
 *
 * Split into a class helper and a body, rather than being one component, because one of the two
 * rows is a router `<Link>` and the other a `<button>`: nesting a button inside an anchor to
 * share a single component is invalid markup.
 *
 * ### Why this file exists
 *
 * Both of these were declared inside `AccountSwitcherPanel.tsx` in
 * `rf-mls-vendor-dashboard-v2`, which is not carried here — this console is admin/internal and
 * has no accounts to switch between (docs/07-decisions.md D13). They are generic menu-row
 * primitives with nothing account-switcher-specific about them, so they were extracted rather
 * than deleted with their former host.
 */
export function shellMenuRowClass(className?: string) {
  return cn(
    'flex w-full items-center gap-3 rounded-lg px-2 py-3 text-start text-base font-semibold text-gdx-nav transition-colors hover:bg-gdx-indigo-tint hover:text-ds-text-accent dark:text-slate-300 dark:hover:bg-slate-800',
    FOCUS_RING,
    className
  );
}

export type ShellMenuRowProps = {
  icon: ReactNode;
  label: string;
};

export function ShellMenuRowContent({ icon, label }: ShellMenuRowProps) {
  return (
    <>
      <span className="flex h-5 w-5 shrink-0 items-center justify-center text-gdx-nav-muted">
        {icon}
      </span>
      {label}
    </>
  );
}
